export const GET_DASHBOARD_PERFORMANCE_ABORTED =
  'GET_DASHBOARD_PERFORMANCE_ABORTED';
export const GET_DASHBOARD_PERFORMANCE_REQUESTED =
  'GET_DASHBOARD_PERFORMANCE_REQUESTED';
export const GET_DASHBOARD_PERFORMANCE_COMPLETED =
  'GET_DASHBOARD_PERFORMANCE_COMPLETED';
export const GET_DASHBOARD_PERFORMANCE_FAILED =
  'GET_DASHBOARD_PERFORMANCE_FAILED';
export const SET_DASHBOARD_PERFORMANCE_FILTER_REQUESTED =
  'SET_DASHBOARD_PERFORMANCE_FILTER_REQUESTED';
export const SET_DASHBOARD_PERFORMANCE_FILTER_COMPLETED =
  'SET_DASHBOARD_PERFORMANCE_FILTER_COMPLETED';
export const SET_DASHBOARD_PERFORMANCE_FILTER_FAILED =
  'SET_DASHBOARD_PERFORMANCE_FILTER_FAILED';

export const RESET_DASHBOARD_PERFORMANCE_REQUESTED =
  'RESET_DASHBOARD_PERFORMANCE_REQUESTED';
export const RESET_DASHBOARD_PERFORMANCE_COMPLETED =
  'RESET_DASHBOARD_PERFORMANCE_COMPLETED';
